// snippet: rcep
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import styles from './AdminSettingForm.styles';
import AdminSettingFormControls from './AdminSettingFormControls';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import axios from 'axios';
import { initialSettings } from '../../../reducers/data';
import { updateData, initialData } from '../../../api/common/actions';
import { readSettings } from '../../../helpers/board';
import box_type_enum from '../../Common/box_type_enum';

export class AdminSettingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retryAttempts: 0,
      maxRetries: 3
    };
  }
  handleBack = () => {
    this.props.history.push('/RearStock/AdminPanel');
  };

  onDataSourceChange = async (event, status) => {
    if ([true, 'true'].includes(status)) {
      await this.getBoxesData(status);
      if (window.getBoxDataInterval) {
        clearInterval(window.getBoxDataInterval);
      }
      window.getBoxDataInterval = setInterval(async () => {
        await this.getBoxesData(status);
      }, process.env.REACT_APP_KIOSK_HEALTH_INTERVAL);
    } else {
      if (
        ![undefined, 'undefined', null, 'null', ''].includes(
          window.getBoxDataInterval
        )
      ) {
        clearInterval(window.getBoxDataInterval);
      }
    }
  };

  getBoxesData = async (status) => {
    const { retryAttempts, maxRetries } = this.state;
    let boxId;
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      boxId = fileData ? fileData.boxId : '';
    } else {
      boxId = localStorage.getItem('boxId');
    }
    if (status === false || status === null) {
      if (window.getBoxDataInterval) {
        clearInterval(window.getBoxDataInterval);
      }
      this.props.initialData(initialSettings);
      return true;
    } else {
      const token = localStorage.getItem('authTokens');
      const actualToken = atob(token);
      if (![undefined, 'undefined', null, null, ''].includes(boxId)) {
        return await axios
          .get(`${process.env.REACT_APP_BASEURL}getprescriptions/${boxId}`, {
            headers: {
              Authorization: 'Bearer ' + actualToken,
              'Content-Type': 'application/json'
            },
            timeout: process.env.REACT_APP_REQUEST_TIMEOUT_INTERVAL
          })
          .then((response) => {
            if (
              response &&
              response.data &&
              response.data.box &&
              response.data.box.id
            ) {
              this.props.updateData(response.data);
            }
            if (
              response &&
              response.data &&
              response.data.box &&
              response.data.box.type_id === box_type_enum.FASTLANE
            ) {
              localStorage.setItem('boxType', response.data.box.type_id);
            }
            this.props.updateData(response.data);
            localStorage.setItem(
              'is_install_mode',
              response.data.box.is_install_mode
            );
            return response.data;
          })
          .catch((error) => {
            if (retryAttempts < maxRetries) {
              this.setState(
                { retryAttempts: retryAttempts + 1 },
                this.getBoxesData()
              );
            } else {
              console.log(error);
            }
          });
      }
    }
  };

  timeoutPromise = (ms, promise) => {
    try {
      return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
          if ([true, 'true'].includes(localStorage.getItem('isKioskOnline'))) {
            window.dispatchEvent(new Event('offline'));
          }
          return;
        }, ms);
        promise.then(
          (res) => {
            clearTimeout(timeoutId);
            resolve(res);
          },
          (err) => {
            clearTimeout(timeoutId);
            reject(err);
          }
        );
      });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { classes, patients } = this.props;
    return (
      <div className={classNames(classes.container)}>
        <div className={classNames(classes.form)}>
          <AdminSettingFormControls
            patients={patients}
            handleBack={this.handleBack}
            onDataSourceChange={this.onDataSourceChange}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ box, pollingStats }) => ({
  box,
  ...pollingStats
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (box) => dispatch(updateData(box)),
  initialData: (box) => dispatch(initialData(box))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withStyles(styles, { withTheme: true })(
    injectIntl(withRouter(AdminSettingForm))
  )
);
